module.exports = __webpack_public_path__ + "img/signed_img.a36eea8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/signed_img.png
// module id = H5We
// module chunks = 1 87